import * as sentry from '../../src/utils/sentry'
import { Translations } from '../../../shared/i18n/Translations'

export function I18N_localizeString<path extends string>(
    path: path,
    substitutions?: { [key: string]: string | number }
): string {
    return Translations.t(`app:${path}`, substitutions)
}

export function I18N_localizeReact<path extends string>(
    path: path,
    substitutions: { [key: string]: React.ReactNode }
): React.ReactNode[] {
    // Replace all {{key}} in the i18n files with {%:key}.
    // This is so we can identify the substitution keys later.
    // \w is a word character (alphanumeric or underscore)
    const text = Translations.t(`app:${path}`).replace(/{{(\w+)}}/g, '{%:$1}')

    // Replace all instances of {%:mySubstitutionName} with the corresponding
    // substitution
    return text.split(/{(%:\w+)}/g).map((fragment) => {
        if (fragment.startsWith('%:') === false) {
            return fragment
        }

        const key = fragment.slice(2)
        const value = substitutions[key]

        if (value == null) {
            sentry.err('i18n: missing substitution', { tags: { key } })
            return `{${fragment}}`
        }

        return value
    })
}
